// extracted by mini-css-extract-plugin
module.exports = {"stepTypeWrapper":"AssetTag_stepTypeWrapper__3IDtl","text":"AssetTag_text__Pw_8P"};